import React from 'react';
import { Datagrid, ReferenceManyField, TextField } from 'react-admin';

import StatusField from '../../../Common/Partials/StatusField';
import TextLink from '../../../Common/Utils/TextLink';

type Props = {
  basePath: string,
  record: any,
  resource: string
};

const LinkedCampaignsTab = (props: Props) => (
  <ReferenceManyField
    allowEmpty
    basePath={props.basePath}
    label="Campaigns"
    record={props.record}
    reference="helpers/linked_campaigns"
    resource={props.resource}
    sort={{ field: 'name', order: 'ASC' }}
    target="placement_id"
  >
    <Datagrid>
      <TextField source="code" />
      <TextLink
        baseName="campaign_sites"
        record={props.record}
        source="name"
        target="_blank" />
      <StatusField source="active" record={props.record} />
    </Datagrid>
  </ReferenceManyField>
);

export default LinkedCampaignsTab;



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/LinkedCampaignsTab.tsx